import { PayServiceApi } from '../api/PayServiceApi';
import { PaymentServicesObj } from '../general/orderbox/order_box';
import { getUserSuid } from '../general/modules/getUserSuid';
import { PaymentObject } from '../types/payments';
import { PaymentServices } from './paymentServices';
import { ClientEventEmitter } from '../marketing/ClientEventEmitter';
import { ClientEvents } from '../constants/clientEvents';
import { CurrentUser } from '../general/modules/user/currentUser';

type InitiateTransactionResponse = number

export class PayService {
    public static async getMethods(): Promise<PaymentServicesObj> {
        const data: GetAllPaymentMethods = {
            amount: window.app.last_payment_object.price,
            country: window.app.config.country,
            currency: window.app.last_payment_object.currency,
            locale: window.app.config.locale,
            suid: CurrentUser.getInstance().getSuid()
        };
        return PayServiceApi.post('payments/getPaymentMethods', data);
    }

    public static async getPaymentMethods(data: GetPaymentMethodsRequest): Promise<PaymentMethodsObj> {
        const app = window.app.isSite1 ? 'triumph' : 'totalbattle';
        return PayServiceApi.post(`payments/${data.serviceName}/${app}/getPaymentMethods`, data);
    }

    public static async initiateTransaction(
        pmObject: PaymentObject,
        payService: PaymentServices
    ): Promise<InitiateTransactionResponse> {
        const initiateTransaction: InitiateTransactionResponse = await PayServiceApi.post('/payments/initiate', {
            payService,
            pmObject,
            suid: getUserSuid(),
            suid_simulate: getUserSuid(true)
        });

        this.setLastPaymentMethod(payService);
        ClientEventEmitter.fireEvent(ClientEvents.PAYMENT_PROCEED, {
            paymentId: pmObject.id,
            paymentMethod: payService,
            transactionId: initiateTransaction
        });

        return initiateTransaction;
    }

    private static setLastPaymentMethod(payService: PaymentServices): void {
        if (payService) {
            window.app.lastPaymentMethod = payService;
            return;
        }

        window.Sentry.captureException(payService);
    }
}

type GetPaymentMethodsRequest = {
    country: string,
    currency: string,
    id: number,
    locale: string,
    price?: number,
    serviceName: string,
    suid: string
};

type GetAllPaymentMethods = {
    country: string,
    currency: string
    amount: number
    locale: string
    suid: string
}

export type PaymentMethod = {
    isInFrame?: boolean,
    weight: number
    isCard?: boolean
    isBaseCardMethod?: boolean,
    universalCheckout?: boolean
};

export type PaymentMethodsObj = {
    [key: string]: PaymentMethod
};
